import { createContext } from 'react';

export const serverBaseUrlContext = createContext();

export const searchQueryContext = createContext();

export const showDashboardContext = createContext();
